export default {
    category: {},
    selectedCategory: {},
    subcategory: {},
};